import { topicsData } from '@/mocks/homepage';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门话题</h2>
          <p className="text-sm text-foreground-500 mt-2">大家都在关注的热门标签</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <div
              key={topic.id}
              className="flex items-center gap-2 px-4 py-2.5 bg-background-100 rounded-full hover:bg-background-200 transition-colors cursor-pointer group whitespace-nowrap"
            >
              {topic.hot && (
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
              )}
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}